import React from 'react';
import { Grid} from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

const TriggerSettingSkeleton = () => {
  return (
    <Grid container spacing={1} style={{ height: '500px' }}>
         <Grid item xs={12} style={{ height: '100px' }}>
        <div style={{ height: '100%' }}>
          <Skeleton variant="rect" width="100%" height="100%" style={{borderRadius: '6px'}} />
        </div>
      </Grid>
      <Grid item xs={6} style={{ height: '150px' }}>
        <div style={{ height: '100%' }}>
          <Skeleton variant="rect" width="100%" height="100%" style={{borderRadius: '6px'}} />
        </div>
      </Grid>
      <Grid item xs={6} style={{ height: '150px' }}>
        <div style={{ height: '100%' }}>
          <Skeleton variant="rect" width="100%" height="100%" style={{borderRadius: '6px'}} />
        </div>
      </Grid>
      <Grid item xs={6} style={{ height: '250px'  }}>
        <div style={{ height: '100%' }}>
          <Skeleton variant="rect" width="100%" height="100%" style={{borderRadius: '6px' }} />
        </div>
      </Grid>
      <Grid item xs={6} style={{ height: '250px' }}>
        <div style={{ height: '100%' }}>
          <Skeleton variant="rect" width="100%" height="100%"  style={{borderRadius: '6px'}}/>
        </div>
      </Grid>
    </Grid>
  );
};

export default TriggerSettingSkeleton;
